<template>
  <div class="tw-pt-1">
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <SidebarMenuButton
          size="lg"
          class="tw-w-full tw-justify-between !tw-rounded-full tw-bg-neutral-50 !tw-px-1 !tw-py-2"
        >
          <div class="tw-flex tw-items-center tw-gap-3">
            <Avatar class="tw-h-10 tw-w-10">
              <AvatarFallback>
                {{ user?.member?.first_name?.charAt(0)?.toUpperCase() || "U" }}
              </AvatarFallback>
            </Avatar>
            <div class="tw-text-left">
              <p class="tw-text-sm tw-font-medium tw-truncate tw-max-w-[120px]">
                {{ user?.member?.first_name }} {{ user?.member?.last_name }}
              </p>
              <p class="tw-text-xs tw-text-muted-foreground tw-truncate tw-max-w-[120px]">
                {{ user?.email }}
              </p>
            </div>
          </div>
          <ChevronsUpDown class="tw-h-4 tw-w-4 tw-mr-1" />
        </SidebarMenuButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" class="tw-w-[225px]">
        <DropdownMenuItem class="tw-cursor-auto">
          <div class="tw-flex tw-flex-col tw-items-start">
            <p class="tw-text-sm tw-font-medium">{{ user?.member?.first_name }} {{ user?.member?.last_name }}</p>
            <p class="tw-text-xs tw-text-muted-foreground">
              {{ user?.email }}
            </p>
          </div>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem @click="handleLogout">
          <LogOut class="tw-mr-2 tw-h-4 tw-w-4" />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/store/user-store"
import { storeToRefs } from "pinia"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu"
import { SidebarMenuButton } from "@/components/ui/sidebar"
import { LogOut, ChevronsUpDown } from "lucide-vue-next"

const emit = defineEmits<{
  logout: []
}>()

const userStore = useUserStore()
const { user } = storeToRefs(userStore)

function handleLogout() {
  userStore.logout()
  emit("logout")
}
</script>
